/** @jsx jsx */
import { jsx } from "theme-ui";
import React, { useState } from "react";

const Copyright: React.FC = () => {
  const [year] = useState(new Date().getFullYear());
  return (
    <div sx={{ color: "white" }}>
      ©{year} {"AirportLink Pty Ltd"}, All Rights Reserved
    </div>
  );
};

export default Copyright;
